<template>
  <div class="page-content ticket egl-dialog-elm original-dialog">
    <h1 class="page-title">
      {{ $locale("sideMenu.couponLib.ticketVoucher") }}
    </h1>

    <!-- Search Area -->
    <el-row class="search-area">
      <el-col :span="14">
        <el-row>
          <el-col :span="13" class="search-item">
            <el-input
              :placeholder="$locale('form.plsEnterYourName')"
              v-model="searchValue" @keyup.enter.native="getList()"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="getList()"></i>
            </el-input>
          </el-col>
          <el-col :span="7" class="search-item">
            <el-select
              :placeholder="$locale('global.allType')"
              v-model="selectValue"
            >
              <el-option
                v-for="(item, index) in type"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" class="search-item">
            <el-button class="egl-btn-yellow" @click="getList()">{{
              $locale("global.search")
            }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10">
        <el-row>
          <el-col :span="24" class="search-item ta-r">
            <el-button disabled class="egl-btn-gray" v-if="getApproveItem">{{
              $locale("global.approve")
            }}</el-button>
            <el-button class="egl-btn-yellow" v-else @click="approve_fn">{{
              $locale("global.approve")
            }}</el-button>
            <el-button class="egl-btn-yellow" @click="isDialogShow('create')">{{
              $locale("global.create")
            }}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- <div class="ticketList"> -->
      <el-table :data="tableData" class="egl-table list-table" stripe>
        <el-table-column :label="$locale('global.change')" width="50" align="center">
          <template slot-scope="scope">
            <i class="el-icon-circle-check change" v-show="!scope.row.approve"></i>
          </template>
        </el-table-column>
        <el-table-column
          :label="$locale('global.name')"
          prop="name"
          min-width="200"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.ticketType')"
          prop="ticketType"
          min-width="100"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.amountOfBoxOfficeRevenue')"
          prop="boxOfficeAmount"
          min-width="150"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.ticketPrintAmount')"
          prop="actualAmount"
          min-width="150"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.numOfIssues')"
          prop="useCount"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.used')"
          prop="usedNumber"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.useNumber')"
          prop="useNumber"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$locale('couponLib.expiredDate')"
          prop="expiredDate"
          min-width="220"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$locale('global.hiddenSetting')"
          prop="displaySetting"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column :label="$locale('global.control')" min-width="180" align="center">
          <template slot-scope="scope">
            <div class="handle">
              <div>
                <a @click="jump(scope.row.id)">{{$locale("couponLib.serialCode")}}</a>
                <el-divider direction="vertical"></el-divider>
              </div>
              <a @click="isDialogShow('detail', scope.row.id)">{{$locale("global.detail")}}</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="isDialogShow('edit', scope.row.id)">{{$locale("global.edit")}}</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="approve_fn('delete', scope.row.name, scope.row.id)">{{$locale("global.delete")}}</a>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <CommPagination
        :total="count"
        :curPage="curPage"
        :pageSize="pageSize"
        @current-change="pageChange"
      />
    <!-- </div> -->

    <el-dialog
      :visible.sync="show"
      width="980px"
      @close="closeHandler"
      class="egl-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        <div class="tipsBox">
          <p>
            {{
              $locale("sideMenu.couponLib.ticketVoucher") +
              " " +
              $locale("global.create") +
              " / " +
              $locale("global.edit")
            }}
          </p>
          <el-tooltip
            :content="
              $locale('sideMenu.couponLib.ticketVoucher') +
              ' ' +
              $locale('global.create') +
              ' / ' +
              $locale('global.edit')
            "
            placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
      </div>
      <div class="dialog-content">
        <el-form
          label-position="top"
          :model="form"
          class="setForm"
          ref="ticketForm"
          :rules="rules"
          :disabled="isDetailDialog"
        >
          <div class="tipsBox">
            <div class="form-module-tit tipsBox">{{ $locale("global.basicInfo") }}</div>
            <el-tooltip :content="$locale('global.basicInfo')" placement="top"
              ><span class="tipIcon"></span
            ></el-tooltip>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$locale('global.name')" prop="name">
                <el-input
                  v-model="form.name"
                  :placeholder="$locale('form.plsEnterYourName')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$locale('couponLib.ticketType')"
                prop="ticketType"
              >
                <el-select
                  v-model="form.ticketType"
                  :placeholder="$locale('couponLib.plsSelectTicketType')"
                >
                  <el-option
                    v-for="item in ticketTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                :label="$locale('couponLib.displayOrder_asce')"
                prop="sort"
              >
                <el-input
                  v-model.number="form.sort"
                  :placeholder="$locale('form.plsEnterNum')"
                  maxlength="5"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$locale('couponLib.amountOfBoxOfficeRevenue')"
                prop="boxOfficeAmount"
              >
                <el-input
                  v-model="form.boxOfficeAmount"
                  :placeholder="$locale('form.plsEnterAmount')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$locale('couponLib.ticketPrintAmount')"
                prop="actualAmount"
              >
                <el-input
                  v-model="form.actualAmount"
                  :placeholder="$locale('form.plsEnterAmount')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$locale('rules.alertMessage')">
                <el-row
                  :gutter="20"
                  class="message"
                  v-for="(item, idx) in form.checkMessages"
                  :key="idx"
                >
                  <el-col :span="8">
                    <el-select v-model="item.platforms">
                      <el-option
                        v-for="platform in platforms"
                        :key="platform.value"
                        :label="platform.label"
                        :value="platform.value"
                        :disabled="isPlatformDisabled(platform.value, idx)"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input v-model="item.checkMsg" :placeholder="$locale('form.plsEnterMsg')" />
                  </el-col>
                  <el-col :span="8">
                    <el-button class="decrease" @click="decreaseMessage(idx)" v-if="form.checkMessages.length > 1">
                      <i class="el-icon-minus"></i>
                    </el-button>
                    <el-button class="increase" @click="increaseMessage" v-if="showBtn('increase', idx) && !isDetailDialog" >
                      <i class="el-icon-plus"></i>
                    </el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item
                :label="$locale('rules.mobolize')"
                prop="actualNumber"
              >
                <el-select v-model="form.actualNumber">
                  <el-option :value="true" :label="$locale('global.yes')"></el-option>
                  <el-option :value="false" :label="$locale('global.no')"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <hr class="dotted" />

          <div class="tipsBox">
            <div class="form-module-tit">
              {{ $locale("couponLib.termsOfUse") }}
            </div>
            <el-tooltip
              :content="$locale('couponLib.termsOfUse')"
              placement="top"
              ><span class="tipIcon"></span
            ></el-tooltip>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$locale('couponLib.expirationType')"
                prop="choose"
                :required="true"
              >
                <el-select
                  v-model="form.choose"
                  @change="selectType"
                >
                  <el-option
                    v-for="item in expiredType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                :label="$locale('couponLib.validDate')"
                prop="expiredDate"
                v-if="form.expiredType === 'DATE'"
              >
                <!-- <CommDatePicker
                  v-model="form.expiredDate"
                  :value.sync="form.expiredDate"
                  width="100%"
                  :format="reflectDate + ` - yyyy/MM/dd`"
                  :pickerOptions="datePickerOptions"
                  :editable="false"
                /> -->
                <DatePickerGroup
                  v-bind:start="form.effectiveDate"
                  v-bind:end="form.expiredDate"
                  :isNotLimit="true"
                  @setFatherDate="getDate"
                ></DatePickerGroup>
              </el-form-item>

              <el-form-item
                :label="$locale('couponLib.validDate')"
                v-if="form.choose === 'duration'"
                prop="durationValue"
              >
                <div class="duration">
                  <el-col :span="16">
                    <el-input
                      v-model="form.durationValue"
                    />
                  </el-col>
                  <el-col :span="8">
                    <el-select
                      v-model="form.expiredType"
                      @change="selectUnit"
                    >
                      <el-option
                        v-for="item in dateUnit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <template v-if="adminType !== 'brand'">
              <el-col :span="8">
                <el-form-item :label="$locale('global.versions')" prop="usableVersion1">
                  <el-select v-model="form.usableVersion1">
                    <el-option
                      v-for="item in versionList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$locale('global.otherVersions')" prop="usableVersion3">
                  <el-select v-model="form.usableVersion3">
                    <el-option
                      v-for="item in otherVersionList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$locale('theatre.seatType')" prop="usableSeatType">
                  <el-select v-model="form.usableSeatType">
                    <el-option
                      v-for="item in seatTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item
                :label="$locale('couponLib.validDate')"
                prop="expiredDate"
                v-if="form.expiredType === 'DATE'"
              >
                <CommDatePicker
                  v-model="form.expiredDate"
                  :value.sync="form.expiredDate"
                  width="100%"
                  :format="reflectDate + ` - yyyy/MM/dd`"
                  :pickerOptions="datePickerOptions"
                  :editable="false"
                />
              </el-form-item>

              <el-form-item
                :label="$locale('couponLib.validDate')"
                v-if="form.choose === 'duration'"
                prop="durationValue"
              >
                <div class="duration">
                  <el-col :span="16">
                    <el-input
                      v-model="form.durationValue"
                    />
                  </el-col>
                  <el-col :span="8">
                    <el-select
                      v-model="form.expiredType"
                      @change="selectUnit"
                    >
                      <el-option
                        v-for="item in dateUnit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                </div>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$locale('couponLib.useNumber')"
                prop="useNumber"
              >
                <el-input v-model="form.useNumber" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$locale('couponLib.available_day')"
                prop="schedule"
              >
                <WeeklyDaySelect
                  :action="curDialogType"
                  :scheduleData="form.schedule"
                ></WeeklyDaySelect>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$locale('couponLib.notAvailable_day')"
                prop="noSchedule"
              >
                <WeeklyDaySelect
                  :action="curDialogType"
                  :scheduleData="form.noSchedule"
                ></WeeklyDaySelect>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item :label="$locale('rules.ticketID.forCurrentCinemaLoyalty')">
                <el-input v-model="form.couponCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item :label="$locale('rules.cl')">
                <el-select v-model="form.clCouponId" clearable>
                  <el-option v-for="(item, idx) in clCouponList" :key="idx" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <hr class="dotted" />

          <el-row class="cinema" v-if="adminType !== 'cinema'">
            <div class="tipsBox">
              <div class="form-module-tit">
                {{ $locale("global.applicableTheater") }}
              </div>
              <el-tooltip
                :content="$locale('global.applicableTheater')"
                placement="top"
                ><span class="tipIcon"></span
              ></el-tooltip>
            </div>

            <el-form-item
              v-model="form.cinemas"
              prop="cinemas"
              :rules="{
                required: true,
                message: $locale('couponLib.plsSelectApplicableTheater'),
                trigger: 'blur'
              }"
              style="margin-bottom: 30px;"
            >
            <el-table
              :data="cinemas"
              stripe
              ref="cinemaTable"
              @selection-change="cinemaSelect"
              @select-all="cienmaSelectAll"
              class="egl-table list-table"
              style="width: 100%; margin-bottom: 0;"
            >
              <el-table-column
                :type="isDetailDialog ? '' : 'selection'"
                min-width="50"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$locale('global.cinemaName')"
                prop="name"
                min-width="100"
              ></el-table-column>
              <el-table-column
                :label="$locale('global.streetAddress') + '1'"
                prop="name"
                min-width="120"
              ></el-table-column>
              <el-table-column
                :label="$locale('global.streetAddress') + '2'"
                prop="name"
                min-width="120"
              ></el-table-column>
            </el-table>
            </el-form-item>
          </el-row>

          <!-- <hr class="dotted" v-if="adminType !== 'cinema'" /> -->

          <div class="tipsBox">
            <div class="form-module-tit">利用設定</div>
            <el-tooltip
              :content="$locale('global.displaySettings')"
              placement="top"
              ><span class="tipIcon"></span
            ></el-tooltip>
          </div>

          <!-- <div class="form-module-tit">
            {{ $locale("global.unDispRelatedSettings") }}
          </div> -->

          <el-form-item label="利用不可設定">
            <div class="checkbox-buttons">
              <el-button
                @click="selectBtn('displayPos')"
                :class="!form.displayPos && 'on'"
                >{{ $locale("global.POS") }}</el-button
              >
              <el-button
                @click="selectBtn('displaySelfCashier')"
                :class="!form.displaySelfCashier && 'on'"
                >{{ $locale("global.selfCheckout") }}</el-button
              >
              <el-button
                @click="selectBtn('displayOnline')"
                :class="!form.displayOnline && 'on'"
                >{{ $locale("global.bookOnline") }}</el-button
              >
            </div>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$locale('global.btnBackgroundColor') + '（' + $locale('global.POS') + '）'"
                prop="bgColor"
              >
                <ColorPicker v-model="form.bgColor" @change="clearFormValidate('bgColor')" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$locale('global.btnTextColor') + '（' + $locale('global.POS') + '）'"
                class="colorPicker white"
                prop="fontColor"
              >
                <ColorPicker v-model="form.fontColor" @change="clearFormValidate(fontColor)" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="10" v-if="adminType !== 'brand'">
              <el-form-item
                :label="$locale('form.displayPOS')"
                prop="groupId"
              >
                <el-select
                  :placeholder="$locale('form.plsSelectGroupofSale_POS')"
                  v-model="form.groupId"
                >
                  <el-option
                    v-for="item in groupArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$locale('global.displayOrder') + '（' + $locale('global.POS') + '）'"
                prop="sortPos"
              >
                <el-input
                  :placeholder="$locale('form.plsEnterNumDispOrder_POS')"
                  v-model.number="form.sortPos"
                  maxlength="5"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <ApproveField
                v-if="!form.approve"
                v-model="form.reflectDate"
                :formData="form"
                fieldName="reflectDate"
                @change="approveChangeAction"
              />
            </el-col>
          </el-row>
          <div class="form-module" @click="handleIsValidCodeClick" v-if="curDialogType === 'edit'">
            <el-row :gutter="40">
              <el-col :span="8">
                <el-form-item label="有効済みシリアルコード">
                  <el-switch
                    :value="form.isValidCode"
                    active-text="反映する"
                    inactive-text="反映しない"
                    active-color="#F9DA49"
                    >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="egl-btn-white" v-if="!isDetailDialog"
        >{{ $locale("global.cancel") }}</el-button>
        <el-button @click="save" class="egl-btn-yellow" v-if="!isDetailDialog"
        >{{ $locale("global.confirm") }}</el-button>
        <el-button @click="cancel()" class="egl-btn-yellow" v-if="isDetailDialog"
        >{{ $locale("global.close") }}
        </el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog
      :visible.sync="approveShow"
      :show-close="false"
      class="egl-dialog approve_dialog"
      @close="approve_close_handler"
    >
      <div class="dialog-content">
        <p>{{ $locale("schedule.reflectionTime") }}</p>
        <div class="datepicker">
          <el-button @click="setApproveD" class="egl-btn-yellow">
            <i class="el-icon-arrow-left"></i>
          </el-button>
          <el-date-picker
            value-format="yyyy-MM-dd"
            format="yyyy/MM/dd"
            type="date"
            v-model="approveDate"
            :clearable="false"
            width="100%"
          />
          <el-button @click="setApproveD('plus')" class="egl-btn-yellow">
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
        <p v-if="adminType === 'brand'">
          {{ $locale("global.applicableTheater") }}
        </p>
        <div class="approve_cinemas" v-if="adminType === 'brand'">
          <el-checkbox
            v-model="approveCinemas.all"
            :key="approveCinemas.all"
            :label="approveCinemas.all"
            @change="selectApproveCinema"
            >全て</el-checkbox
          >
          <el-checkbox-group v-model="approveCinemas.cinemas">
            <el-checkbox
              v-for="item in cinemas"
              :key="item.id"
              :label="item.id"
              :disabled="approveCinemas.all"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-show="type !== 'detail'">
        <el-button class="egl-btn-white" @click="approve_D_Show">{{
          $locale("global.cancel")
        }}</el-button>
        <el-button class="egl-btn-yellow" @click="approve_fn">{{
          $locale("global.confirm")
        }}</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  getCinemaList,
  getGroupListService,
  getVersion,
  getOtherVersion,
  getGroupListForCounponService
} from "@/helpers/service/api/common";
import {
  getAdvCouponTypeListService,
  getAdvCouponTypeDetailService,
  addAdvCouponTypeService,
  updateAdvCouponTypeService,
  delAdvCouponTypeService,
  advCouponTypeUpdateApproveService,
} from "@/helpers/service/api/ticket";

import { getCLCouponListService } from '@/helpers/service/api/ruleTemplate'
import countDownAlert from "@/utils/countDownAlert";
import { priceFormat, weekSelectArray } from "@/utils/common";
import ApproveField from "@/components/common/ApproveField";
import ColorPicker from "@/components/common/ColorPicker";
import CommPagination from "@/components/common/CommPagination";
// import CommDatePicker from "@/components/common/CommDatePicker";
import DatePickerGroup from "@/components/DatePickerGroup";
import WeeklyDaySelect from "@/components/common/WeeklyDaySelect";
import { positiveNumValidator, hexColorValidator } from "@/utils/formFieldValidator";
import "@/assets/style/ticket.less";

export default {
  created() {
    this.cinemaId = window.localStorage.getItem("cinemaId");
    this.brandId = window.localStorage.getItem("brandId");
    // let dictionary = window.localStorage.getItem("dictionary") || "";
    // let seatTypeList = [];
    this.getList();

    // if (dictionary != "") {
    //   let arr = [];

    //   dictionary = JSON.parse(dictionary);

    //   arr = Object.keys(dictionary.ticketing.SeatStatus);

    //   arr.map(val => {
    //     seatTypeList.push({
    //       label: val,
    //       value: val,
    //     });
    //   });
    // }

    // this.seatTypeList = seatTypeList;
    getCLCouponListService({ brandId: window.localStorage.getItem('brandId')}).then(res => {
      if (res.data && res.data.length > 0) {
        this.clCouponList = res.data
      }
    })
    getCinemaList({
      page: 0,
      pageSize: 9999,
    }).then(res => {
      let { data: { data }, } = res;

      data.forEach(item => {
        item.cinemaId = item.id;
        item.cinemaName = item.name;
      });

      this.cinemas = data;
    });

    getVersion(
      {
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      },
      false,
      false
    ).then(res => {
      if (res.success) {
        this.versionList = res.data.data;
      }
    });
    getOtherVersion(
      {
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      },
      false,
      false
    ).then(res => {
      if (res.success) {
        this.otherVersionList = res.data.data;
      }
    });
    if (this.adminType === "cinema") {
      getGroupListService({
        cinemaId: this.cinemaId,
        type: "ticketType",
      }).then(res => {
        this.groupArr = [{ id: '', name: this.$locale('global.none')}, ...(
            res.data && res.data.length > 0 ? res.data : []
          )]
      });
    } else {
      getGroupListForCounponService({
        brandId: this.brandId,
        type: "advanceCoupom",
        page: 0,
        pageSize: 9999,
      }).then(res => {
        this.groupArr = this.groupArr = [{ id: null, name: this.$locale('global.none')}, ...(
            res.data && res.data.length > 0 ? res.data : []
          )]
      });
    }
  },
  data() {
    return {
      cinemaId: "",
      brandId: "",
      count: 0,
      curPage: 0,
      pageSize: 10,
      show: false,
      approveShow: false,
      approveDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      curDialogType: "",
      curId: "",
      approveCinemas: {
        all: false,
        cinemas: [],
      },
      ticketTypeArr: [
        {
          label: this.$locale("couponLib.theaterAdvTicket"),
          value: "PRE_SALES",
        },
        {
          label: this.$locale("couponLib.invitationTicket"),
          value: "INVITATION",
        },
      ],
      platforms: [
        {
          label: this.$locale("global.webCconsole"),
          value: "webconsole",
          isDis: false,
        },
        {
          label: this.$locale("global.POS"),
          value: "pos",
          isDis: false,
        },
        {
          label: this.$locale("global.selfCashier"),
          value: "selfCashier",
          isDis: false,
        },
        {
          label: this.$locale("global.scanner"),
          value: "scanner",
          isDis: false,
        },
        {
          label: this.$locale("global.pwa"),
          value: "pwa",
          isDis: false,
        },
      ],
      today: this.$moment(new Date()).format("YYYY/MM/DD"),
      dateTypeObj: {
        DAYS: "expiredDays",
        MONTHLY: "expiredMonth",
        YEAR: "expiredYear",
      },
      expiredType: [
        {
          label: this.$locale("couponLib.deadline"),
          value: "DATE",
        },
        {
          label: this.$locale("couponLib.period"),
          value: "duration",
        },
        {
          label: this.$locale("couponLib.unlimited"),
          value: "NONE",
        },
      ],
      dateUnit: [
        {
          label: this.$locale("calendar.year"),
          value: "YEAR",
        },
        {
          label: this.$locale("calendar.month"),
          value: "MONTHLY",
        },
        {
          label: this.$locale("calendar.day"),
          value: "DAYS",
        },
      ],
      expiredmodel: {
        DATE: "expiredType",
        NONE: "expiredType",
        duration: "fake",
      },
      scheduleText: this.$locale("couponLib.wholePeriod"),
      noScheduleText: this.$locale("global.none"),
      adminType: window.localStorage.getItem("adminType"),
      weekArr: weekSelectArray,
      monthOption: this.getMonthArr(),
      cinemas: [],
      groupArr: [],
      searchValue: "",
      selectValue: "",
      isApprove: false,
      isCreateShow: false,
      isDetailShow: false,
      isEditShow: false,
      ticketType: {
        PRE_SALES: this.$locale("couponLib.theaterAdvTicket"),
        INVITATION: this.$locale("couponLib.invitationTicket"),
      },
      tableData: [],
      type: [
        {
          label: this.$locale("global.selectAll"),
          value: "all",
        },
        {
          label: this.$locale("couponLib.theaterAdvTicket"),
          value: "PRE_SALES",
        },
        {
          label: this.$locale("couponLib.invitationTicket"),
          value: "INVITATION",
        },
      ],
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      form: this.initFormData(),
      rules: {
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur"
        } ],
        ticketType: [ {
          required: true, message:
          this.$locale("couponLib.plsSelectTicketType"),
          trigger: "change"
        } ],
        boxOfficeAmount: [ {
          required: true,
          message: this.$locale("couponLib.plsEnteramountOfBoxOfficeRevenue"),
          trigger: "blur"
        } ],
        expiredDate: [
          { required: true, message: this.$locale("couponLib.plsEnterExpiredDate"), trigger: "blur" }
        ],
        durationValue: [
          { required: false, message: this.$locale("couponLib.plsEnterExpiredDate"), trigger: "blur" }
        ],
        useNumber: [ {
          required: true,
          message: this.$locale("couponLib.plsEnterUseNumber"),
          trigger: "blur"
        } ],
        usableVersion1: [ {
          required: true,
          message: this.$locale("couponLib.plsSelectVersion1"),
          trigger: "change",
        } ],
        usableSeatType: [ {
          required: true,
          message: this.$locale("couponLib.plsSelectSeatType"),
          trigger: "change"
        } ],
        sort: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        sortPos: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        bgColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
        fontColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
      },
      versionList: [],
      otherVersionList: [],
      seatTypeList: [
        {
          label: this.$locale("couponLib.seatType.special"),
          value: "special"
        },
        {
          label: this.$locale("couponLib.seatType.general"),
          value: "general"
        },
        {
          label: this.$locale("couponLib.seatType.wheelchair"),
          value: "wheelchair"
        },
        {
          label: this.$locale("couponLib.seatType.vip"),
          value: "vip"
        },
        {
          label: this.$locale("couponLib.seatType.lovers"),
          value: "lovers"
        },
        {
          label: this.$locale("theatre.seat.windowSeat"),
          value: "posCounter"
        }
      ],
      clCouponList: [],
    };
  },
  watch: {
    form: {
      handler: function() {
        this.platforms.forEach(item => {
          item.isDis = false;
        });

        this.form.checkMessages.forEach(item => {
          this.platforms.forEach(item2 => {
            if (item.platforms === item2.label) {
              item2.isDis = true;
            }
          });
        });
      },
      deep: true,
    },
  },
  computed: {
    getApproveItem() {
      if (this.tableData.length === 0) {
        return true;
      }

      const isDisabled = !this.tableData.find(item => item.approve === false);
      return isDisabled;
    },
    isDetailDialog() {
      return this.curDialogType === "detail";
    },
    reflectDate() {
      const _expiredDate = this.form.reflectDate ? this.form.reflectDate : this.$moment().valueOf();
      return this.$moment(_expiredDate).format("YYYY/MM/DD");
    },
    effectiveDate() {
      const _expiredDate = this.form.effectiveDate ? this.form.effectiveDate : this.$moment().valueOf();
      return this.$moment(_expiredDate).format("YYYY/MM/DD");
    },
  },
  methods: {
    isPlatformDisabled(platformValue, currentIdx) {
      return this.form.checkMessages.some((msg, idx) => idx !== currentIdx && msg.platforms === platformValue);
    },
    getDate(obj) {
      const { startDate, endDate } = obj || {};
      this.form.effectiveDate = startDate;
      this.form.expiredDate = endDate;
      if (startDate && startDate > endDate) {
        this.form.effectiveDate = endDate;
        // this.form.expiredDate = this.$moment(startDate).add(1, "day").startOf("day").valueOf();
      }
      if (endDate && endDate < startDate) {
        this.form.effectiveDate = startDate;
        // this.form.expiredDate = endDate;
      }
    },
    createShow(type, id) {
      this.isCreateShow = !this.isCreateShow;
      if (type === "edit") {
        this.setValue(id, type);
      }
    },
    setValue(id) {
      getAdvCouponTypeDetailService({ id }, true, this.curDialogType === "edit").then(res => {
        if (!res.data.noEdit || this.curDialogType === "detail") {
          const {
            data: {
              expiredDate,
              expiredType,
              expiredYear,
              expiredMonth,
              expiredDays,
            },
          } = res;
          const chooseKeyword = ["YEAR", "MONTHLY", "DAYS"];
          const durationMapping = {
            YEAR: expiredYear,
            MONTHLY: expiredMonth,
            DAYS: expiredDays,
          };

          this.form = {
            ...res.data,
            expiredDate: expiredDate ? expiredDate : new Date().valueOf(),
            choose: chooseKeyword.includes(expiredType.toUpperCase())
              ? "duration"
              : expiredType,
            durationValue: durationMapping[expiredType],
            isValidCode: res.data.isValidCode !== undefined ? res.data.isValidCode : false,
          };

          this.getScheduleText("scheduleText", "schedule");
          this.getScheduleText("noScheduleText", "noSchedule");
          this.show = !this.show;
          this.autoSelectCinema(res.data);
        }
      });
    },
    autoSelectCinema(res) {
      const { cinemas } = this;
      const res_cinemas = res.cinemas;
      this.$nextTick(() => {
        res_cinemas.forEach(row => {
          if (this.$refs.cinemaTable) {
            this.$refs.cinemaTable.toggleRowSelection(cinemas.find(item => {
              return row.cinemaId === item.id;
            }), true);
          }
        });
      });

    },
    approve_D_Show() {
      this.approveShow = !this.approveShow;
    },
    getList(pageValue) {
      getAdvCouponTypeListService({
        ...(this.searchValue ? { name: this.searchValue } : {}),
        ...(this.selectValue && this.selectValue !== "all" ? { ticketType: this.selectValue } : {}),
        ...(this.adminType === "brand" ? { brandId: this.brandId } : { cinemaId: this.cinemaId }),
        page: pageValue ? pageValue - 1 : 0,
        pageSize: this.pageSize,
      }).then(res => {
        this.count = res.data.count;
        let _data = res.data.data;
        _data.forEach(item => {
          item.ticketType = this.ticketType[item.ticketType];
          item.actualAmount = "¥ " + priceFormat(item.actualAmount);
          item.boxOfficeAmount = "¥ " + priceFormat(item.boxOfficeAmount);
        });
        this.tableData = _data;
      });
    },
    approve_fn(type, name, id) {
      // let name = '';
      let confirmHtml = "";
      if (type === "delete") {
        confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}?</span>`;
      } else {
        confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;
      }
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      })
        .then(() => {
          if (type === "delete") {
            this.deleteRow(id);
          } else {
            advCouponTypeUpdateApproveService({
              ...this.adminType === "brand" ? { brandId: this.brandId } : {},
              ...this.adminType === "cinema" ? { cinemaId: this.cinemaId } : {}
            }).then(() => {
              this.getList();
            });
          }
        })
        .catch(() => {});
    },
    isDialogShow(type, id) {
      this.curDialogType = type;
      if (id) {
        if (this.$refs.ticketForm) { this.$refs.ticketForm.resetFields(); }
        this.curId = id;
        this.setValue(id);
      }
      if(type === "create") {
        this.form = this.initFormData();
        if (this.$refs.ticketForm) { this.clearFormValidate(); }
        this.show = !this.show;
      }
    },
    deleteRow(id) {
      delAdvCouponTypeService({ id }).then(res => {
        if(!res.message) {
          this.countDown(this.$locale("global.deleteSuccessfully"));
        }
      });
    },
    closeHandler() {
      this.reset();
      this.otherReset();
    },
    cancel() {
      this.show = !this.show;
    },
    submit() {},
    increaseMessage() {
      if (this.form.checkMessages.length >= this.platforms.length) { return; }
      this.form.checkMessages.push({
        platforms: "",
        checkMsg: "",
      });
    },
    decreaseMessage(idx) {
      this.form.checkMessages.splice(idx, 1);
    },
    showBtn(type, idx) {
      if (type === "increase") {
        if (
          this.form.checkMessages.length > 1 &&
          this.form.checkMessages.length < this.platforms.length &&
          this.form.checkMessages.length - 1 === idx
        ) {
          if (idx === 0) {
            return false;
          }
          return true;
        } else if (this.form.checkMessages.length === 1) {
          return true;
        }
        return false;
      }
    },
    selectType(val) {
      switch (val) {
      case "DATE":
        this.clearFormValidate("durationValue");
        this.form.expiredType = "DATE";
        delete this.rules.durationValue;
        this.rules.expiredDate = [
          {
            required: true,
            message: this.$locale("couponLib.plsEnterExpiredDate"),
            trigger: "blur",
          }
        ];
        break;
      case "NONE":
        this.form.expiredType = "NONE";
        if (this.rules.durationValue) {
          delete this.rules.durationValue;
        } else {
          delete this.rules.expiredDate;
        }
        break;
      case "duration":
        this.clearFormValidate("expiredDate");
        this.form.expiredType = "YEAR";
        delete this.rules.expiredDate;
        this.rules.durationValue = [
          {
            required: true,
            message: this.$locale("couponLib.plsEnterExpiredDate"),
            trigger: "blur",
          },
        ];
        break;
      default:
        break;
      }
    },
    selectUnit() {
      switch (this.form.expiredType) {
      case "YEAR":
        this.form.expiredYear = "";
        break;
      case "MONTHLY":
        this.form.expiredMonth = "";
        break;
      case "DAYS":
        this.form.expiredDays = "";
        break;
      default:
        break;
      }
    },
    setD(type) {
      let d = new Date(this.form.expiredDate);
      if (type === "plus") {
        d.setDate(d.getDate() + 1);
      } else if (d > new Date()) {
        d.setDate(d.getDate() - 1);
      }
      this.form.expiredDate = d;
    },
    setApproveD(type) {
      let d = new Date(this.approveDate);
      if (type === "plus") {
        d.setDate(d.getDate() + 1);
      } else if (d > new Date()) {
        d.setDate(d.getDate() - 1);
      }
      this.approveDate = d;
    },
    getMonthArr() {
      let arr = [];
      for (let i = 0; i < 31; i++) {
        arr.push({
          label: `${i + 1}${this.$locale("calendar.day")}`,
          value: `${i + 1}`,
        });
      }
      return arr;
    },
    selectAll(key, arrName) {
      this.form[arrName].week = [];
      this.form[arrName].month = [];
      if (this.form[arrName].all) {
        this[key] = this.$locale("couponLib.wholePeriod");
      } else {
        this[key] = this.$locale("global.none");
      }
    },
    getScheduleText(key, arrName) {
      let str = "";
      let strdata = "";
      let str_m = "";
      let strdata_m = "";
      this.form[arrName].week.forEach(item => {
        this.weekArr.forEach((item2, idx) => {
          if (item === item2.value) {
            if (this.form[arrName].week.length === 1) {
              str = `${this.$locale("calendar.weekly")}${
                item2.label
              }${this.$locale("calendar.weekday")}`;
            } else {
              if (idx === this.form[arrName].week.length - 1) {
                strdata += `${item2.label}`;
              } else {
                strdata += `${item2.label}、 `;
              }
              str = `${this.$locale("calendar.weekly")}${strdata}${this.$locale("calendar.weekday")}`;
            }
          }
        });
      });
      this.form[arrName].month.forEach(item => {
        this.monthOption.forEach((item2, idx) => {
          if (item === item2.value) {
            if (this.form[arrName].month.length === 1) {
              str_m = `${this.$locale("calendar.monthly")}${
                item2.value
              }${this.$locale("calendar.day")}`;
            } else {
              if (idx === this.form[arrName].month.length - 1) {
                strdata_m += `${item2.value}`;
              } else {
                strdata_m += `${item2.value}、 `;
              }
              str_m = `${this.$locale("calendar.monthly")}${strdata_m}${this.$locale("calendar.day")}`;
            }
          }
        });
      });
      if (str_m && str) {
        this[key] = `${str_m}/${str}`;
      } else if (str_m) {
        this[key] = `${str_m}`;
      } else {
        this[key] = `${str}`;
      }
    },
    cinemaSelect(selection) {
      this.form.cinemas = [];
      // this.form.cinemas = val;
      let _arr = selection;
      _arr.forEach(item => {
        this.form.cinemas.push({
          approve: this.form.approve || false,
          cinemaId: item.id,
          cinemaName: item.name
        });
      });

      this.clearFormValidate("cinemas");
    },
    cienmaSelectAll(selection) {
      if (selection.length === 0) {
        this.form.cinemas = [];
      } else {
        this.form.cinemas = [];
        selection.forEach(item => {
          this.form.cinemas.push({
            approve: this.form.approve || false,
            cinemaId: item.id,
            cinemaName: item.name,
          });
        });
      }

      this.clearFormValidate("cinemas");
    },
    selectBtn(type) {
      if (this.curDialogType !== "detail") {
        this.form[type] = !this.form[type];
      }
    },
    reset() {
      this.$refs.ticketForm.resetFields();
      this.form.reflectDate = this.$moment().startOf("day").valueOf();
    },
    otherReset() {
      // 其他field reset
      this.form.checkMessages = [
        {
          checkMsg: "",
          platforms: null,
        },
      ];
      this.form.expiredType = "DATE";
      this.form.expiredDays = "";
      this.form.expiredMonth = "";
      this.form.expiredYear = "";
      this.form.schedule = {
        all: true,
        month: [],
        week: [],
      };
      this.scheduleText = this.$locale("couponLib.wholePeriod");
      this.form.noSchedule = {
        all: false,
        month: [],
        week: [],
      };
      this.noScheduleText = this.$locale("global.none");
      this.form.cinemas = [];
      if (this.$refs.cinemaTable) {
        this.$refs.cinemaTable.clearSelection();
      }
      this.form.displayPos = true;
      this.form.displaySelfCashier = true;
      this.form.displayOnline = true;
    },
    save() {
      this.$refs.ticketForm.validate(valid => {
        let callType = "";
        let cinema = [];
        if (this.curDialogType === "edit") {
          callType = "update";
          cinema = this.form.cinemas;
        } else {
          callType = "create";
          if (this.adminType === "cinema") {
            this.cinemas.forEach(item => {
              cinema.push({
                cinemaId: item.cinemaId,
                cinemaName: item.cinemaName,
                approve: false,
              });
            });
          } else {
            // cinema = this.form.cinemas;
            this.form.cinemas.forEach(item => {
              cinema.push({
                cinemaId: item.cinemaId,
                cinemaName: item.cinemaName,
                approve: false,
              });
            });
          }
        }
        if (valid) {
          const requestParam = {
            brandId: window.localStorage.getItem("brandId"),
            ...(this.curDialogType === "edit" ? { id: this.curId } : {}),
            actualAmount: this.form.actualAmount
              ? parseInt(this.form.actualAmount)
              : 0,
            actualNumber: this.form.actualNumber,
            baseType: "DISCOUNT",
            type: this.adminType,
            bgColor: this.form.bgColor,
            boxOfficeAmount: parseInt(this.form.boxOfficeAmount),
            checkMessages: this.form.checkMessages,
            ...(this.adminType === "cinema" ? { cinemaId: this.cinemaId } : {}),
            cinemas: cinema,
            displayOnline: this.form.displayOnline,
            displayPos: this.form.displayPos,
            displaySelfCashier: this.form.displaySelfCashier,
            ...(this.form.expiredType === "DATE"
              ? { expiredDate: this.$moment(this.form.expiredDate).add(1, "day").startOf("day").valueOf() }
              : {}),
            ...(this.form.expiredType === "DAYS"
              ? { expiredDays: this.form.durationValue }
              : {}),
            ...(this.form.expiredType === "MONTHLY"
              ? { expiredMonth: this.form.durationValue }
              : {}),
            ...(this.form.expiredType === "YEAR"
              ? { expiredYear: this.form.durationValue }
              : {}),
            expiredType: this.form.expiredType,
            fontColor: this.form.fontColor,
            groupId: this.form.groupId,
            name: this.form.name,
            noSchedule: this.form.noSchedule,
            schedule: this.form.schedule,
            sort: parseInt(this.form.sort),
            sortPos: parseInt(this.form.sortPos),
            ticketType: this.form.ticketType,
            useNumber: parseInt(this.form.useNumber),
            usableSeatType: this.form.usableSeatType,
            usableVersion1: this.form.usableVersion1,
            usableVersion3: this.form.usableVersion3,
            reflectDate: this.$moment(this.form.reflectDate).startOf("day").valueOf(),
            effectiveDate: this.$moment(this.form.effectiveDate).startOf("day").valueOf(),
            couponCode: this.form.couponCode,
            clCouponId: this.form.clCouponId,
            syncOldCoupons: this.form.isValidCode,
          };

          const requestScuessFn = showText => {
            this.show = !this.show;
            this.countDown(showText);
          };

          if (callType === "create") {
            addAdvCouponTypeService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.createSuccessfully"));
            });
          } else {
            updateAdvCouponTypeService(requestParam).then(() => {
              requestScuessFn(this.$locale("global.updateSuccessfully"));
            });
          }
          // this.$refs.ticketPage.$refs.page.internalCurrentPage = 1;
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    selectApproveCinema() {
      this.approveCinemas.cinemas = [];
    },
    countDown(str) {
      countDownAlert({
        content: str,
        callback: () => {
          this.getList(this.curPage + 1);
        }
      });
    },
    pageChange(value) {
      this.curPage = value - 1;
      this.getList(value);
    },
    jump(id) {
      this.$router.push({ path: "/ticketlist/" + id });
    },
    approve_close_handler() {
      this.approveDate = new Date();
      this.approveCinemas.all = false;
      this.approveCinemas.cinemas = [];
    },
    initFormData() {
      return {
        name: "",
        ticketType: "",
        sort: 0,
        boxOfficeAmount: "",
        actualAmount: "",
        expiredType: "DATE",
        expiredDate: this.$moment().add(1, "day").startOf("day").valueOf(),
        expiredDays: "",
        expiredMonth: "",
        expiredYear: "",
        useNumber: 1,
        schedule: {
          all: true,
          month: [],
          week: [],
        },
        noSchedule: {
          all: false,
          month: [],
          week: [],
        },
        cinemas: [],
        bgColor: "#FFFFFF",
        fontColor: "#000000",
        groupId: '',
        sortPos: 0,
        checkMessages: [
          {
            platforms: null,
            checkMsg: "",
          },
        ],
        choose: "DATE",
        displayPos: true,
        displaySelfCashier: true,
        displayOnline: false,
        durationValue: "",
        usableSeatType: null,
        usableVersion1: null,
        usableVersion3: null,
        reflectDate: this.$moment().startOf("day").valueOf(),
        effectiveDate: this.$moment().startOf("day").valueOf(),
        actualNumber: "",
        couponCode: "",
        clCouponId: "",
        isValidCode: false,
      };
    },
    clearFormValidate(fieldName) {
      if (fieldName) {
        this.$refs.ticketForm.clearValidate(fieldName);
      } else {
        this.$refs.ticketForm.clearValidate();
      }
    },
    approveChangeAction(_value) {
      if (this.form.expiredDate && _value > this.form.expiredDate) {
        this.form.expiredDate = _value;
      }
    },
    dateDisableDate(time) {
      const { reflectDate } = this.form;
      const _today = this.$moment();
      const _limit = reflectDate && reflectDate > _today ? reflectDate : _today.startOf("day").valueOf();
      return time.getTime() < _limit;
    },
    handleIsValidCodeClick(event) {
      // 阻止默认的切换行为
      event.preventDefault();

      // 如果当前是关闭状态，点击要开启，需要确认
      if (!this.form.isValidCode) {
        let confirmHtml = "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">反映しますか？</span>";
        this.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("global.confirm"),
          customClass: "egl-confirm",
          closeOnClickModal: false
        }).then(() => {
          // 用户确认，切换开关状态
          this.form.isValidCode = true;
        }).catch(() => {
          // 用户取消，不做任何操作
        });
      } else {
        // 如果当前是开启状态，点击要关闭，直接切换
        this.form.isValidCode = false;
      }
    },
  },
  components: {
    ApproveField,
    ColorPicker,
    CommPagination,
    // CommDatePicker,
    WeeklyDaySelect,
    DatePickerGroup,
  },
};
</script>
